import React from 'react';
import { ThemeProvider } from 'contexts/ThemeContext';
import { LanguageProvider } from 'contexts/LanguageContext';
import Home from 'pages/Home';
import HackerMode from 'components/HackerMode';

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="portfolio-theme">
      <LanguageProvider storageKey="portfolio-lang">
        <Home />
        <HackerMode />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
